import React from 'react';
/*
 * Bronson Paragraph component.
 */
export function Paragraph({ children, className, testId, ...otherProps }) {
    return (React.createElement("p", { ...otherProps, "data-testid": testId, className: className }, children));
}
